module.exports = __webpack_public_path__ + "static/p7-7f8d068791b9be0d604f2a9c234f9d2a.jpg";